import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.scss'],
    standalone: false
})
export class SecurityComponent implements OnInit {
  documents = [
    {
      title: "K16's Security and Architecture",
      titleTranslationKey: 'k16_security_and_architecture',
      descriptionTranslationKey:
        'this_document_provides_a_description_of_the_technical_and_organizational_security_controls',
      description:
        'This document provides a description of the technical and organizational security controls implemented by K16 Solutions.',
      link: 'https://k16-hosted-files.s3.us-east-2.amazonaws.com/upload/K16+-+Security+Documentation.pdf',
      linkText: 'K16 - Security Documentation.pdf',
    },

    {
      title: 'SOC 2 TYPE I',
      titleTranslationKey: 'soc_2_type_i',
      descriptionTranslationKey: '',
      descriptions: [
        {
          type: 'text',
          text: `Our SOC 2 report is a detailed overview of our commitment to security, availability, processing integrity, confidentiality, and privacy. It provides customers with independent assurance that our systems and processes meet industry-standard criteria established by the
        American Institute of Certified Public Accountants (AICPA). The SOC 2 reports cover controls around security, availability, and confidentiality of customer data.`,

          descriptionTranslationKey:
            'our_soc_2_report_is_a_detailed_overview_of_our_commitment_to_security',
        },
        {
          type: 'text',
          descriptionTranslationKey:
            'additional_information_about_soc_2_reports_can_be_found_at',
          text: `Additional information about SOC 2 reports can be found at:`,
        },
        {
          type: 'link',
          text: 'https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report',
          link: `https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report`,
        },
      ],
      //       description: `
      // <a href='https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report' target="_blank">https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report</a>`,
      //       link: "https://k16-hosted-files.s3.us-east-2.amazonaws.com/upload/K16+SOC+2+Type+1+Report+6-30-22_vFINAL.pdf",
    },
    {
      link: 'https://k16-hosted-files.s3.us-east-2.amazonaws.com/upload/K16+SOC+2+Type+1+Report+6-30-22_vFINAL.pdf',
      linkText: 'K16 SOC 2 Type 1 Report 6-30-22_vFINAL.pdf',
    },

    {
      title: 'PEN TEST REPORT',
      titleTranslationKey: 'pen_test_report',
      descriptionTranslationKey:
        'our_penetration_test_report_is_a_transparent_demonstration_of_our_commitment_to_the_security_and_trust_of_our_customers',
      description: `Our penetration test report is a transparent demonstration of our commitment to the security and trust of our customers. It provides a comprehensive overview of the simulated attack on our systems and the vulnerabilities identified, along with the steps we have taken to remediate them. By sharing this report, we aim to provide our customers with assurance that we take security seriously and are committed to ensuring the protection of their data.`,
      link: 'https://k16-hosted-files.s3.us-east-2.amazonaws.com/upload/K16-Solutions-Scaffold+SAAS+Platform+Penetration+Test+(2022-Q4)-+Executive+summary+.pdf',
      linkText:
        'K16-Solutions-Scaffold SAAS Platform Penetration Test (2022-Q4)- Executiive summary.pdf',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
